export const SUPPORT_EMAIL = "support@traceforgood.com"
